class ApiHandlerService {
    handleResponse(req, page) {
        req.then((res) => {
            const data = res.data;
            page.message = data.message;
            page.isLoading = false;
            page.showDialog = true;
            page.showSuccess = data.status !== "failure";
        }).catch((err) => {
            console.log("Error: ", err);
            page.isLoading = false;
        });
    }

    handleError(error, page) {
        page.isLoading = false;
        console.log("Error: ", error);
    }
}
export default new ApiHandlerService();
